import BuyAccountInfo from "./BuyAccountInfo"

const obj = {}

obj.install = function (Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(BuyAccountInfo)

    //2.用new 的方式用组件构造器创建出来组件对象
    const buyAccountInfo = new Construct()

    //3.将组件对象手动挂载到某一个元素上
    buyAccountInfo.$mount(document.createElement('div'))

    //4.buyAccountInfo.$el对应的就是div
    document.body.appendChild(buyAccountInfo.$el)

    //5.在原型中加入BuyAccountInfo
    Vue.prototype.$BuyAccountInfo = buyAccountInfo

}

export default obj
